type ConnectionStateListener = (isConnected: boolean) => void;

export type ListenerId = number;

export const tizenExit = () => {
  try {
    window.tizen.application.getCurrentApplication().exit();
  } catch (e) {
    if (window.tizen) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(new Error('Exit: ' + message));
    }
  }
};

const isNetworkConnected = (state: any): boolean => {
  try {
    return state === window.webapis.network.NetworkState.GATEWAY_CONNECTED;
  } catch (e) {
    if (window.webapis) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(
        new Error(`isNetworkConnected: ${message}`)
      );
    }
  }
  return false;
};

export const addConnectionStateListener = (
  listener: ConnectionStateListener
): ListenerId | undefined => {
  try {
    return window.webapis.network.addNetworkStateChangeListener(
      (state: any) => {
        listener(isNetworkConnected(state));
      }
    ) as ListenerId | undefined;
  } catch (e) {
    if (window.webapis?.network) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(
        new Error(`addNetworkStateChangeListener: ${message}`)
      );
    }
  }
};

export const removeConnectionStateListener = (listenerId: ListenerId): void => {
  try {
    window.webapis.network.removeNetworkStateChangeListener(listenerId);
  } catch (e) {
    if (window.webapis?.network) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(
        new Error(`removeNetworkStateChangeListener: ${message}`)
      );
    }
  }
};
